import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { logo } from "../../../images";
import { device } from "../../../helpers";

const Image = styled.img`
    display: block;
    width: 48px;

    @media ${device.phone} {
        display: none;
    } ;
`;

export default function Logo() {
    return (
        <Link to="/app/">
            <Image src={logo} />
        </Link>
    );
}
